'use strict';
/*
 * Module: fetchtv.Directives
 * Directive: ftCardValidation
 */
(function(angular) {
  angular.module('fetchtv.Directives')
    .directive('ftCardValidation', ['payment', function(payment) {
      return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
          validCardTypes: '&'
        },
        compile: function() {
          function postLink(scope, iElement, iAttrs, ngModel) {
            ngModel.$parsers.unshift(function(value) {
              var card = payment.cardFromNumber(value),
                whiteList = scope.validCardTypes() || [];
              if (angular.isDefined(value)) {
                ngModel.$setValidity('cardNumberLength', value.replace(/ /g, '').length > 15);
              }

              if (card) {
                ngModel.$setValidity('cardTypeValid', (whiteList.indexOf(card.type) > -1));
              }
              return value;
            });
          }
          return {
            post: postLink
          };
        }
      };
    }]);
})(angular);

